// Small presentational helpers shared by the desktop + mobile version timelines.

import { PencilLine, RotateCcw, Sparkles, Wand2 } from 'lucide-react'
import type { CreativeVersionKind } from '../../store/versions-store'

/** Glyph for a version's origin kind. */
export function kindIcon(kind: CreativeVersionKind) {
  switch (kind) {
    case 'generate':
      return <Sparkles className="h-3 w-3" />
    case 'ai':
      return <Wand2 className="h-3 w-3" />
    case 'restore':
      return <RotateCcw className="h-3 w-3" />
    default:
      return <PencilLine className="h-3 w-3" />
  }
}

/** Compact relative time ("just now", "5m", "3h", "2d"). */
export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime()
  if (!Number.isFinite(then)) return ''
  const s = Math.max(0, Math.round((Date.now() - then) / 1000))
  if (s < 60) return 'just now'
  const m = Math.round(s / 60)
  if (m < 60) return `${m}m`
  const h = Math.round(m / 60)
  if (h < 24) return `${h}h`
  return `${Math.round(h / 24)}d`
}
